import React from "react";
import "./ComingSoon.css";

const ComingSoon = () => {
  return (
    <section className="coming-soon-page">
      <div className="coming-soon-content">
        <p className="coming-soon-eyebrow">Batkidshotel</p>
        <h1 className="coming-soon-title">Coming Soon</h1>
        <p className="coming-soon-subline">Something is in the works. Check back later.</p>
        <a href="/" className="coming-soon-back">← Back to The Creaks</a>
      </div>
    </section>
  );
};

export default ComingSoon;
